import React from 'react';
import swal from '@sweetalert/with-react';
import { createLabSections, deleteSection, updateManualPlacement } from './Helpers';

const getSectionsWithoutLabs = (sections) => {
  return sections.filter(section => section.labs.length === 0);
}
const getSectionsWithLabs = (sections) => {
  return sections.filter(section => section.labs.length > 0);
}
const getPlacedSections = (sections) => {
  return sections.filter(section => section.course_period_ids.length > 0);
}
const handleLabSectionsAlert = async (action = 'create' || 'remove', num_sections) => {
  const options =  {
    title: action === 'create' ? `Add Lab Section(s)?` : `Remove Lab Section(s)?`,
    dangerMode: true,
    buttons: {
      cancel: {
        text: "No",
        value: false,
        visible: true,
        className: 'gray-btn'
      },
      confirm: {
        text: action === 'create' ? "Yes, add labs" : "Yes, remove labs",
        value: true,
        visible: true,
        className: action === 'create' ? 'blue-btn' : 'red-btn'
      },
    },
    content: (
      <div>
        <p>You have {num_sections} placed section(s) {action === 'create' ? 'without' : 'with'} labs, do you want us to {action === 'create' ? 'add' : 'remove'} labs for those sections?</p>
      </div>
    )
  }

  return await swal(options);		
}

export const updateLabSections = async (sections, new_value, school_id, schedule_version_id, department_id, setSections = (sections) => {}) => {
  if (new_value === '1') {
    const sectionsWithoutLabs = getSectionsWithoutLabs(sections);
    if (sectionsWithoutLabs.length > 0) {
      const placedSectionsWithoutLabs = getPlacedSections(sectionsWithoutLabs);
      const labSectionsToCreate = [];
      let shouldCreatePlaced = false;

      if (placedSectionsWithoutLabs.length > 0) {
        shouldCreatePlaced = await handleLabSectionsAlert('create', placedSectionsWithoutLabs.length);
      }

      for (const section of sectionsWithoutLabs) {
        if (!shouldCreatePlaced && section.course_period_ids.length > 0)
          continue;
          
        labSectionsToCreate.push(section.section_id);
      }

      if (labSectionsToCreate.length > 0) {
        const createdSections = await createLabSections({ school_id, schedule_version_id, main_sections_ids: labSectionsToCreate });

        if (!createdSections || (createdSections.sections && createdSections.sections.length === 0)) {
          return;
        }

        const updateManualPlacementPromises = [];
        
        for (const placedSectionWithoutLab of placedSectionsWithoutLabs) {
          if (!placedSectionWithoutLab.course_period_ids || placedSectionWithoutLab.course_period_ids.length === 0)
            continue;

          const new_course_period_id = placedSectionWithoutLab.course_period_ids[0];
          updateManualPlacementPromises.push(updateManualPlacement({ school_id, schedule_version_id, department_id, update_type: 'add', section_info: placedSectionWithoutLab, new_course_period_id, current_day: null }));
        }

        // stringify values for frontend
        createdSections.sections = createdSections.sections.map(section => {
          return { ...section, section_id: String(section.section_id), teacher_id: String(section.teacher_id), course_id: String(section.course_id), is_lab: String(section.is_lab), is_inclusion: String(section.is_inclusion), is_manual: String(section.is_manual), locked: String(section.locked), departments: [department_id], quarter_days: [], raw_quarter_days: [] };
        });

        try {
          if (updateManualPlacementPromises.length > 0) {
            const updateManualPlacementResponses = await Promise.all(updateManualPlacementPromises);

            for (const response of updateManualPlacementResponses) {
              if (response.returned_sections && response.returned_sections.length > 0) {
                createdSections.sections = createdSections.sections.map(createdSection => {
                  const returnedSection = response.returned_sections.find(section => String(section.section_id) === String(createdSection.section_id));
                  if (returnedSection) {
                    return { ...createdSection, course_periods: returnedSection.course_periods };
                  }
                  return createdSection;
                });
              }
            }
          }
        } catch (error) {
          console.error('Error updating manual placement for lab sections:', error);
        }

        if (createdSections?.sections?.length > 0) {
          setSections(prevSections => {
            return [...prevSections, ...createdSections.sections];
          });
        }
      }
    }
  } else if (new_value === '0') {
    const sectionsWithLabs = getSectionsWithLabs(sections);
    if (sectionsWithLabs.length > 0) {
      const placedSectionsWithLabs = getPlacedSections(sectionsWithLabs);
      const labSectionIdsToRemove = [];
      let shouldDeletePlaced = false;
      
      if (placedSectionsWithLabs.length > 0) {
        shouldDeletePlaced = await handleLabSectionsAlert('remove', placedSectionsWithLabs.length);
      }

      for (const section of sectionsWithLabs) {
        if (!shouldDeletePlaced && section.course_period_ids.length > 0)
          continue;
          
        for (const lab of section.labs) {
          labSectionIdsToRemove.push(lab.section_id);
        }
      }

      if (labSectionIdsToRemove.length >  0) {
        await deleteSection({ school_id: school_id, schedule_version_id: schedule_version_id, section_ids: labSectionIdsToRemove, delete_span_sections: false });

        setSections(prevSections => {
          return prevSections.filter(section => !labSectionIdsToRemove.includes(Number(section.section_id)));
        });
      }
    }	
  }
}